<section id="fit" class="relative scroll-mt-28 overflow-hidden border-t border-surface">
    <app-landing-glow [variant]="5" />
    <div class="relative z-10 mx-auto w-full max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
        <div class="grid gap-8 lg:grid-cols-[0.9fr_1.1fr]">
            <div>
                <div class="text-sm font-semibold uppercase tracking-[0.3em] text-primary">{{ text().fitTitle }}</div>
                <h2 class="mt-4 text-3xl font-semibold text-surface-900 sm:text-4xl dark:text-white">{{ text().fitSubtitle }}</h2>
                <p class="mt-6 max-w-xl text-lg leading-8 text-muted-color">
                    {{ text().fitDescription }}
                </p>
            </div>

            <div class="grid gap-5 md:grid-cols-3">
                @for (card of text().fitCards; track card.title; let i = $index) {
                    <article [appRevealOnScroll]="i * 90" class="rounded-3xl border border-surface bg-gradient-to-b from-primary-100 to-surface-0 p-6 shadow-lg shadow-black/10 dark:from-primary-400/10 dark:to-white/5">
                        <h3 class="text-xl font-semibold text-surface-900 dark:text-white">{{ card.title }}</h3>
                        <p class="mt-3 leading-7 text-muted-color">{{ card.description }}</p>
                    </article>
                }
            </div>
        </div>
    </div>
</section>
